// Globale Variablen
const DELIVERY_PROP = 'Voraussichtlicher Lieferzeitraum';
const STOREFRONT_TOKEN = 'da02442b17d9d7075daaed5155864a83';


// Hilfsfunktionen
function isHoliday(date, holidays) {
  // Ist ein Feiertag?
  const dateStr = date.toISOString().split('T')[0]; // Format: YYYY-MM-DD
  return holidays.includes(dateStr);
}

function getAllHolidays() {
  // alle Feiertage lesen
  const allHolidays = new Set();
    
  if (window.shopMetafields?.holidays) {
    Object.values(window.shopMetafields.holidays).forEach(holidayList => {
      holidayList.forEach(holiday => allHolidays.add(holiday));
    });
  }
    
  return Array.from(allHolidays).sort();
}

function addWeekdays(start, days) {
  // Arbeitstag hinzufügen
  const result = new Date(start);
  let added = 0;
  const allHolidays = getAllHolidays();
    
  while (added < days) {
    result.setDate(result.getDate() + 1);
      
    // Überspringe Sonntage und Feiertage
    if (result.getDay() !== 0 && !isHoliday(result, allHolidays)) {
      added++;
    }
  }
  return result;
}

function formatDate(d) {
  return (
    ("0" + d.getDate()).slice(-2) +
    "." +
    ("0" + (d.getMonth() + 1)).slice(-2) +
    "." +
    d.getFullYear()
  );
}
  
function parseGermanDate(dateStr) {
  const [day, month, year] = dateStr.split('.').map(Number);
  return new Date(year, month - 1, day);
}

function formDataToObject(formData) {
  const obj = {};

  for (const [key, value] of formData.entries()) {
    obj[key] = value;
  }

  return obj;
}

function extractBody(body) {

  // FormData
  if (body instanceof FormData) {
    return {
      type: 'formdata',
      data: formDataToObject(body)
    };
  }

  // JSON-String
  if (typeof body === 'string') {
    try {
      return {
        type: 'string',
        data: JSON.parse(body)
      };
    } catch {
      return null;
    }
  }

  // Objekt
  if (typeof body === 'object' && body !== null) {
    return {
      type: 'object',
      data: body
    };
  }

  return null;
}

function getFormDataItemIndexes(formData) {
  const indexes = new Set();

  for (const key of formData.keys()) {
    const match = key.match(/^items\[(\d+)\]/);
    if (match) {
      indexes.add(Number(match[1]));
    }
  }

  return [...indexes].sort((a, b) => a - b);
}

function getFormDataItemVariantId(formData, index) {
  return (
    formData.get(`items[${index}][id]`) ||
    formData.get(`items[${index}][variant_id]`) ||
    null
  );
}

function formDataHasItemProperty(formData, index, propertyName) {
  return formData.has(`items[${index}][properties][${propertyName}]`);
}

function formDataItemHasGpoParent(formData, index) {
  return formData.has(`items[${index}][properties][_gpo_parent_product_group]`);
}

function formDataHasSingleGpoParent(formData) {
  return formData.has('properties[_gpo_parent_product_group]');
}

function hasUsableMetafields(meta) {
  return !!(
    meta &&
    !(
      (meta.lieferbar_ab == null || meta.lieferbar_ab === '') &&
      (meta.lieferzeit_von == null || meta.lieferzeit_von === '') &&
      (meta.lieferzeit_bis == null || meta.lieferzeit_bis === '')
    )
  );
}

function getProductPageMetafields() {
  const metafieldEl = document.getElementById("product-metafields");

  if (!metafieldEl) {
    return null;
  }

  try {
    return JSON.parse(metafieldEl.textContent || "{}");
  } catch (err) {
    console.warn('[Delivery] product-metafields konnten nicht gelesen werden:', err);
    return null;
  }
}

function calculateDeliveryDateFromMetafields(meta) {
  if (!hasUsableMetafields(meta)) {
    return "";
  }

  const von = parseInt(meta.lieferzeit_von || 0);
  const bis = parseInt(meta.lieferzeit_bis || 0);

  let now = new Date(Date.now());
  now.setHours(0, 0, 0, 0);

  const lieferbarAbDate =
    meta.lieferbar_ab && String(meta.lieferbar_ab).trim()
      ? parseGermanDate(meta.lieferbar_ab)
      : null;

  const startDate = lieferbarAbDate > now ? lieferbarAbDate : now;

  return formatDate(addWeekdays(startDate, von)) + " bis " + formatDate(addWeekdays(startDate, bis));
}


// Hauptfunktionen
async function tryFetchVariantMetafields(variantId) {
  if (!variantId) {
    return null;
  }

  try {
    const metafields = await fetchVariantMetafields(variantId);

    if (hasUsableMetafields(metafields)) {
      return metafields;
    }

    return null;
  } catch (err) {
    console.warn('[Delivery] Variant-Metafields konnten nicht geladen werden:', variantId, err);
    return null;
  }
}

async function fetchVariantMetafields(variantId) {
  if (!variantId) {
    return null;
  }

  const query = `{
    node(id: "gid://shopify/ProductVariant/${variantId}") {
      ... on ProductVariant {
        metafield1: metafield(namespace: "custom", key: "lieferbar_ab") {
          value
        }
        metafield2: metafield(namespace: "custom", key: "lieferzeit_von") {
          value
        }
        metafield3: metafield(namespace: "custom", key: "lieferzeit_bis") {
          value
        }
      }
    }
  }`;

  let response = null;

  try {
    response = await fetch('/api/2024-10/graphql.json', {
      method: 'POST',
      headers: { 
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN
      },
      body: JSON.stringify({ query })
    });
  } catch (err) {
    console.warn('[API] Fetch Variant Metafields Request fehlgeschlagen:', variantId, err);
    return null;
  }

  if (!response.ok) {
    console.warn('[API] Fetch Variant Metafields fehlgeschlagen:', variantId, response.status);
    return null;
  }

  let data = null;

  try {
    data = await response.json();
  } catch (err) {
    console.warn('[API] Variant Metafields Response war kein gültiges JSON:', err);
    return null;
  }

  const node = data?.data?.node;

  return {
    lieferbar_ab: node?.metafield1?.value || "",
    lieferzeit_von: node?.metafield2?.value ? parseInt(node.metafield2.value, 10) : 7,
    lieferzeit_bis: node?.metafield3?.value ? parseInt(node.metafield3.value, 10) : 10
  };
}

async function interceptAddToCart(...args) {
  const body = args[1]?.body;

  if (!body) {
    console.warn('Kein body vorhanden.');
    return args;
  }

  try {
    // ---------------------------------------------------------
    // Variante 1: FormData
    // ---------------------------------------------------------
    if (body instanceof FormData) {
      const itemIndexes = getFormDataItemIndexes(body);

      // -------------------------------------------------------
      // Variante 1A: FormData mit items[0], items[1], ...
      // -------------------------------------------------------
      if (itemIndexes.length > 0) {
        const indexWithDeliveryProp = itemIndexes.find(index =>
          formDataHasItemProperty(body, index, DELIVERY_PROP)
        );

        const sortedIndexes =
          indexWithDeliveryProp !== undefined
            ? [
                indexWithDeliveryProp,
                ...itemIndexes.filter(index => index !== indexWithDeliveryProp)
              ]
            : itemIndexes;

        const mainIndex = sortedIndexes[0];
        const mainVariantId = getFormDataItemVariantId(body, mainIndex);

        const mainMetafieldsFromBackend = await tryFetchVariantMetafields(mainVariantId);
        const useBackendForAllItems = hasUsableMetafields(mainMetafieldsFromBackend);
        const fallbackMetafields = useBackendForAllItems ? null : getProductPageMetafields();

        for (const index of sortedIndexes) {
          if (formDataItemHasGpoParent(body, index)) {
            continue;
          }

          const variantId = getFormDataItemVariantId(body, index);

          let metafields = null;
          if (useBackendForAllItems) {
            if (index === mainIndex) {
              metafields = mainMetafieldsFromBackend;
            } else {
              metafields = await tryFetchVariantMetafields(variantId);
            }
          }

          if (!hasUsableMetafields(metafields) && index === mainIndex) {
            metafields = fallbackMetafields;
          }

          const value = calculateDeliveryDateFromMetafields(metafields);

          if (value) {
            body.set(`items[${index}][properties][${DELIVERY_PROP}]`, value);
          }
        }

        return args;
      }

      // -------------------------------------------------------
      // Variante 1B: klassischer Single-Artikel-FormData-Request
      // -------------------------------------------------------
      if (!formDataHasSingleGpoParent(body)) {
        const variantId = body.get('id') || body.get('variant_id') || null;
        let metafields = await tryFetchVariantMetafields(variantId);

        if (!hasUsableMetafields(metafields)) {
          metafields = getProductPageMetafields();
        }

        const value = calculateDeliveryDateFromMetafields(metafields);

        if (value) {
          body.set(`properties[${DELIVERY_PROP}]`, value);
        }
      }

      return args;
    }

    // ---------------------------------------------------------
    // Variante 2: JSON-String
    // ---------------------------------------------------------
    if (typeof body === 'string') {
      try {
        const parsed = JSON.parse(body);

        // -----------------------------------------------------
        // Variante 2A: JSON-String mit items[]
        // -----------------------------------------------------
        if (parsed.items && Array.isArray(parsed.items)) {
          const itemWithDeliveryProp = parsed.items.find(item =>
            item &&
            item.properties &&
            Object.prototype.hasOwnProperty.call(item.properties, DELIVERY_PROP)
          );

          const sortedItems =
            itemWithDeliveryProp
              ? [
                  itemWithDeliveryProp,
                  ...parsed.items.filter(item => item !== itemWithDeliveryProp)
                ]
              : parsed.items;

          const mainItem = sortedItems[0];

          if (!mainItem) {
            args[1].body = JSON.stringify(parsed);
            return args;
          }

          const mainVariantId = mainItem.id || mainItem.variant_id || null;

          const mainMetafieldsFromBackend = await tryFetchVariantMetafields(mainVariantId);
          const useBackendForAllItems = hasUsableMetafields(mainMetafieldsFromBackend);
          const fallbackMetafields = useBackendForAllItems ? null : getProductPageMetafields();

          for (const item of sortedItems) {
            if (!item) {
              continue;
            }

            if (!item.properties) {
              item.properties = {};
            }

            if (item.properties["_gpo_parent_product_group"]) {
              continue;
            }

            const variantId = item.id || item.variant_id || null;

            let metafields = null;
            if (useBackendForAllItems) {
              if (item === mainItem) {
                metafields = mainMetafieldsFromBackend;
              } else {
                metafields = await tryFetchVariantMetafields(variantId);
              }
            }

            if (!hasUsableMetafields(metafields) && index === mainIndex) {
              metafields = fallbackMetafields;
            }

            const value = calculateDeliveryDateFromMetafields(metafields);

            if (value) {
              item.properties[DELIVERY_PROP] = value;
            }
          }

        // -----------------------------------------------------
        // Variante 2B: JSON-String Single-Artikel
        // -----------------------------------------------------
        } else {
          if (!parsed.properties) {
            parsed.properties = {};
          }

          if (!parsed.properties["_gpo_parent_product_group"]) {
            const variantId = parsed.id || parsed.variant_id || null;
            let metafields = await tryFetchVariantMetafields(variantId);

            if (!hasUsableMetafields(metafields)) {
              metafields = getProductPageMetafields();
            }

            const value = calculateDeliveryDateFromMetafields(metafields);

            if (value) {
              parsed.properties[DELIVERY_PROP] = value;
            }
          }
        }

        args[1].body = JSON.stringify(parsed);
      } catch (e) {
        console.warn('Body ist ein String, aber kein JSON:', e);
      }

      return args;
    }

    // ---------------------------------------------------------
    // Variante 3: Objekt
    // ---------------------------------------------------------
    if (typeof body === 'object' && body !== null) {
      // -------------------------------------------------------
      // Variante 3A: Objekt mit items[]
      // -------------------------------------------------------
      if (body.items && Array.isArray(body.items)) {
        const itemWithDeliveryProp = body.items.find(item =>
          item &&
          item.properties &&
          Object.prototype.hasOwnProperty.call(item.properties, DELIVERY_PROP)
        );

        const sortedItems =
          itemWithDeliveryProp
            ? [
                itemWithDeliveryProp,
                ...body.items.filter(item => item !== itemWithDeliveryProp)
              ]
            : body.items;

        const mainItem = sortedItems[0];

        if (!mainItem) {
          return args;
        }

        const mainVariantId = mainItem.id || mainItem.variant_id || null;

        const mainMetafieldsFromBackend = await tryFetchVariantMetafields(mainVariantId);
        const useBackendForAllItems = hasUsableMetafields(mainMetafieldsFromBackend);
        const fallbackMetafields = useBackendForAllItems ? null : getProductPageMetafields();

        for (const item of sortedItems) {
          if (!item) {
            continue;
          }

          if (!item.properties) {
            item.properties = {};
          }

          if (item.properties["_gpo_parent_product_group"]) {
            continue;
          }

          const variantId = item.id || item.variant_id || null;

          let metafields = null;
          if (useBackendForAllItems) {
            if (item === mainItem) {
              metafields = mainMetafieldsFromBackend;
            } else {
              metafields = await tryFetchVariantMetafields(variantId);
            }
          }

          if (!hasUsableMetafields(metafields) && index === mainIndex) {
            metafields = fallbackMetafields;
          }

          const value = calculateDeliveryDateFromMetafields(metafields);

          if (value) {
            item.properties[DELIVERY_PROP] = value;
          }
        }

      // -------------------------------------------------------
      // Variante 3B: Objekt Single-Artikel
      // -------------------------------------------------------
      } else {
        if (!body.properties) {
          body.properties = {};
        }

        if (!body.properties["_gpo_parent_product_group"]) {
          const variantId = body.id || body.variant_id || null;
          let metafields = await tryFetchVariantMetafields(variantId);

          if (!hasUsableMetafields(metafields)) {
            metafields = getProductPageMetafields();
          }

          const value = calculateDeliveryDateFromMetafields(metafields);

          if (value) {
            body.properties[DELIVERY_PROP] = value;
          }
        }
      }

      return args;
    }

    console.warn('Unbekanntes Body-Format:', body);
    return args;

  } catch (err) {
    console.error('[Cart] Fehler innerhalb interceptAddToCart:', err);
    return args;
  }
}

// Einstiegspunkte
(function() {
  const originalFetch = window.fetch;

  if (window.__cartFetchIntercepted) return;
  window.__cartFetchIntercepted = true;

  const CART_ADD_PATH = '/cart/add';

  window.fetch = async function(...args) {
    // Sicherheitscheck: fetch ohne Argumente nicht selbst weiter kaputt machen
    if (!args || args.length === 0) {
      console.warn('[Fetch] fetch wurde ohne Argumente aufgerufen.');
      return originalFetch.apply(this, args);
    }

    const url = args[0];

    // Request-Objekte oder URL-Objekte sauber weitergeben
    const urlString =
      typeof url === 'string'
        ? url
        : url instanceof Request
          ? url.url
          : url instanceof URL
            ? url.toString()
            : '';

    const isCartAdd = urlString.includes(CART_ADD_PATH);

    if (!isCartAdd) {
      return originalFetch.apply(this, args)
        .catch(err => {
          console.warn('[Fetch] Nicht-Cart-Fetch fehlgeschlagen, abgefangen:', args[0], err);

          return new Response(null, {
            status: 204,
            statusText: 'No Content'
          });
        });
    }

    try {
      const interceptedArgs = await interceptAddToCart(...args);

      // Wichtig: Nur überschreiben, wenn wirklich ein gültiges Array zurückkommt
      if (Array.isArray(interceptedArgs) && interceptedArgs.length > 0) {
        args = interceptedArgs;
      } else {
        console.warn('[Cart] interceptAddToCart hat keine gültigen args zurückgegeben. Verwende Original-args.');
      }

    } catch (err) {
      console.error('[Cart] Fehler in interceptAddToCart:', err);
    }

    try {
      return await originalFetch.apply(this, args);
    } catch (err) {
      console.error('[Cart] Fetch /cart/add fehlgeschlagen:', err);
      return Promise.reject(err);
    }
  };
})();

document.addEventListener('DOMContentLoaded', function() {
  
  document.addEventListener('click', async function(e) {
    const button = e.target.closest('[name="checkout"]:not([name="update"]), button[name="checkout"], .cart__checkout-button, .cart__checkout, [href="/checkout"]');
    
    if (e.target.closest('.cart__remove, [href*="/cart/change"], [data-cart-remove], .cart-item__remove')) {
      return;
    }
    
    if (!button) return;
    
    if (button.dataset.processingCheckout === 'true') {
      e.preventDefault();
      e.stopImmediatePropagation();
      return;
    }
    
    e.preventDefault();
    e.stopImmediatePropagation();
    
    button.dataset.processingCheckout = 'true';
    button.disabled = true;
    
    const originalText = button.textContent;
    button.textContent = 'Wird vorbereitet...';
    
    try {
      const cart = await fetch('/cart.js').then(r => r.json());
      
      const updates = [];
      
      for (let item of cart.items) {
        const itemProperties = item.properties || {};

        if (itemProperties["_gpo_parent_product_group"]) {
          continue;
        }

        const variantId = item.variant_id;
        const metafields = await tryFetchVariantMetafields(variantId);
        const value = calculateDeliveryDateFromMetafields(metafields);

        if (value) {
          updates.push({
            id: item.key,
            quantity: item.quantity,
            properties: {
              ...itemProperties,
              [DELIVERY_PROP]: value
            }
          });
        }
      }
      
      for (let update of updates) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(update)
        });
      }
      
      await new Promise(resolve => setTimeout(resolve, 300));
      
      const form = document.createElement('form');
      form.method = 'POST';
      form.action = '/cart';
      
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'checkout';
      input.value = '1';
      
      form.appendChild(input);
      document.body.appendChild(form);
      form.submit();
      
    } catch (error) {
      console.error('Fehler bei Checkout-Vorbereitung:', error);
      
      button.dataset.processingCheckout = 'false';
      button.disabled = false;
      button.textContent = originalText;
      
      alert('Ein Fehler ist aufgetreten. Bitte versuche es erneut.');
    }
    
  }, true);
  
});